import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const SelectLanguageStyle = (theme: Theme) =>
  createStyles({
    dropdown: {
      fontSize: '0.75rem',
      borderWidth: 0,
      padding: '10px',
      width: 'fit-content',
      backgroundColor: styleColors.transparentWhite,
      color: styleColors.black,
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      letterSpacing: '0.125rem',
      textTransform: 'uppercase',
  },
  });



// WEBPACK FOOTER //
// ./src/components/common/language/SelectLanguage.style.ts